export default {
  C: "C",
  CSharp: "Cis",
  D: "D",
  DFlat: "Des",
  DSharp: "Dis",
  E: "E",
  EFlat: "Es",
  F: "F",
  FSharp: "Fis",
  G: "G",
  GFlat: "Ges",
  GSharp: "Gis",
  A: "A",
  AFlat: "As",
  ASharp: "Ais",
  B: "H",
  BFlat: "B",

  correctExcl: "Poprawna!",
  wrongExcl: "Zła!",

  ABORT: "PRZERWIJ PARTIĘ",

  lastRound: "Poprzednia partia",
  score: "Punkty",
  accuracy: "Poprawność",
  correct: "poprawne",
  wrong: "złe",

  START: "START",
  settings: "Ustawienia",
  ROUND_LENGTH: "DŁUGOŚĆ PARTII",
  NOTE_INPUT: "METODA WEJŚCIA",
  CLEF: "KLUCZ",
  DIFFICULTY: "TRUDNOŚĆ",
  ACCIDENTALS: "ZNAKI CHROMATYCZNE",
  LANGUAGE: "JĘZYK",
  twentySeconds: "20 s",
  oneMinute: "1 min",
  fiveMinutes: "5 min",
  infinite: "Nieskończona",
  buttons: "Przyciski",
  piano: "Klawiatura",
  trebleClef: "wiolinowy",
  bassClef: "basowy",
  altoClef: "altowy",
  tenorClef: "tenorowy",
  pianoClef: "klawiatura",
  both: "Oba",
  easy: "Łatwy",
  normal: "Normalny",
  hard: "Trudny",
  none: "Brak",
  sharp: "♯",
  flat: "♭",
  sharpAndFlat: "♯ i ♭",
  SOUND: "DŹWIĘK",
  VIBRATION: "WIBRACJA",
  DISPLAYCORRECTNOTE: "WYŚWIETLAJ POPRAWNĄ NUTĘ",
  on: "Włącz",
  off: "Wyłącz",

  TIME: "CZAS",
  CORRECT: "POPRAWNE",
  ACCURACY: "POPRAWNOŚĆ",
  SCORE: "PUNKTY",

  record: "Rekord",
  history: "Historia"
};



// WEBPACK FOOTER //
// ./src/resources/pl.js